import {
	Component,
	OnInit,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-insurance-create-external-wizard',
	templateUrl: './insurance-create-external-wizard.component.html',
	styleUrls: ['./insurance-create-external-wizard.component.less'],
	standalone: false,
})
export class InsuranceCreateExternalWizardComponent implements OnInit {

	public frameSrc: SafeResourceUrl;

	constructor(
		public sanitizer: DomSanitizer,
		private activatedRoute: ActivatedRoute,
	) {
	}

	public ngOnInit(): void {
		this.frameSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
			this.activatedRoute.snapshot.queryParams.frameUrl,
		);
	}
}
